/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceNowCmdbActionResourceMapping {
    getFixupPrototypeFunction() { return ServiceNowCmdbActionResourceMapping.fixupPrototype; }

    static newInstance(model: Partial<ServiceNowCmdbActionResourceMapping>): ServiceNowCmdbActionResourceMapping {
        let obj = Object.assign(new ServiceNowCmdbActionResourceMapping(), model);
        ServiceNowCmdbActionResourceMapping.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceNowCmdbActionResourceMapping>): ServiceNowCmdbActionResourceMapping {
        if (!model) return null;
        return ServiceNowCmdbActionResourceMapping.newInstance(<ServiceNowCmdbActionResourceMapping> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceNowCmdbActionResourceMapping) {
        if (!obj) return;

        models.ServiceNowCmdbActionResourceMapping.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceNowCmdbActionResourceMapping): boolean {
        Object.setPrototypeOf(obj, ServiceNowCmdbActionResourceMapping.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.create) {
            for (let val of this.create) {
                models.ServiceNowCmdbAttributeMapping.fixupPrototype(val);
            }
        }
        if (this.update) {
            for (let val of this.update) {
                models.ServiceNowCmdbAttributeMapping.fixupPrototype(val);
            }
        }
        if (this.delete) {
            for (let val of this.delete) {
                models.ServiceNowCmdbAttributeMapping.fixupPrototype(val);
            }
        }
    }

    /**
     * ServiceNow Cmdb CI create attributes mapping
     */
    create: Array<models.ServiceNowCmdbAttributeMapping>;

    /**
     * ServiceNow Cmdb CI update attributes mapping
     */
    update: Array<models.ServiceNowCmdbAttributeMapping>;

    /**
     * ServiceNow Cmdb CI delete attributes mapping
     */
    delete: Array<models.ServiceNowCmdbAttributeMapping>;

}
